import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';
class AuthService extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/common-auth-server/api'
  };
  async login(username: string, password: string) {
    const response = await this.get('/b/auth/login', {
      params: {
        authKey: username,
        authValue: password,
        authType: 'ACCOUNT'
      }
    });
    return response;
  }

  async login2(username: string, password: string) {
    const response = await this.post('/b/auth/admin/login', {
      authKey: username,
      authValue: password,
      authType: 'ACCOUNT'
    });
    return response;
  }

  // 修改密码
  async updatePassword(currentPassword: string, newPassword: string) {
    return await this.post('/b/auth/updatePassword', {
      currentPassword,
      newPassword
    });
  }
  async refreshToken() {
    const response = await this.post('/b/auth/token/refresh');
    return response;
  }
  async logout() {
    return await this.get('/b/auth/logout');
  }
}
export default new AuthService();
